export default __webpack_public_path__ + "static/media/bg-showcase-3.2934c91a.jpg";